<template>
    <div class="jd_sports_item2">
        <template v-if="item.id == 497">
            <div class="tabbody">
                <div class="tabbody-title">
                    <div class="tabbody-title2">活动列表</div>
                </div>
                <div slot="title" class="sports_item_rule_img" @click="showRule=true">
                    <VanImage
                        src="https://oss.mcloud.moveclub.cn/2025/qjyd-hu/%E7%8E%A9%E6%B3%95%E8%A7%84%E5%88%993c.png"
                        fit="cover"
                        width="100%"
                        height="100%"
                    />
                </div>
                <div class="new_list">
                    <div class="html" >一、红色定向赛——红迹漫行・步忆峥嵘<br/>
                    二、活动日期：2025年10月13日-11月10日<br/>
                    三、活动玩法:<br/>
                    微信步数每5000步点亮一个红色点位，点击点位可了解相关红色点位背后的革命故事。点亮10个点位即可完赛。<br/>
                    四、参加办法:<br/>
                    1、按本次活动规程总则规定执行;<br/>
                    2、凡是工作、生活、学习在嘉定区、热爱健身运动的市民(6-65周岁)均可报名参赛。<br/>
                    3、所有参赛者有义务了解个人身体状况，报名参赛者默认已知晓运动风险、自愿参加且身体状况适合参加此项运动，其间发生的任何伤亡及意外事故均由本人负责。<br/>
                    4、在参赛过程中，若因个人身体状况不佳、对风险预判不足、操作不当或其他非主办方故意 / 重大过失导致的任何伤亡、意外事故及财产损失，均由参赛者本人自行承担全部责任，与主办方、承办方及相关协办单位无涉</div>
                    </div>
            </div>
            <Button
                round    
                @click="goTab(item)"
                class="mvbutton"
                style="width: 100%;"
                block
                >立即参与</Button>
        </template>
        <template v-else-if="item.id == 498">
            <div class="tabbody">
                <div class="tabbody-title">
                    <div class="tabbody-title2">活动列表</div>
                </div>
                <div slot="title" class="sports_item_rule_img" @click="showRule=true">
                    <VanImage
                        src="https://oss.mcloud.moveclub.cn/2025/qjyd-hu/%E7%8E%A9%E6%B3%95%E8%A7%84%E5%88%993c.png"
                        fit="cover"
                        width="100%"
                        height="100%"
                    />
                </div>
                <div class="new_list">
                    <div class="new_item" v-for="item in newslist" :key="item.id" @click="gonewsdetail(item.id)">
                        <div class="dot"></div>
                        <div class="text-content">
                            <div class="title">{{ item.title }}</div>
                            <div class="subtitle">点击了解背后的故事</div>
                        </div>
                    </div>
                </div>
                
            </div>
            <Button
                round    
                @click="goquest(1351)"
                class="mvbutton"
                style="width: 100%;"
                block
                >立即答题</Button>
        </template>

        <template v-else>
            <div
                class="tabbody only"
            >
                <div
                class="header"
                >活动介绍</div>
                <div class="html" v-html="rule"></div>
            </div>
            <Button
                round    
                @click="goTab(item)"
                class="mvbutton"
                style="width: 100%;"
                block
                >立即参与</Button>
        </template>
        <!-- <template v-if="subItemList.length===0">
            <div
                class="tabbody no"
            >
                <img src="https://oss.mcloud.moveclub.cn/alphamovecloud/20220730/1659166958/431875.png" alt="">
            </div>
        </template> -->
        

        <van-popup closeable round v-model="showform" style="height: 10rem;width: 6.1rem;">
            <Form :list="attrs" :ispop="true" buttonColor="linear-gradient( 180deg, #FF6900 0%, #FECD87 100%)"  @submit="submit"/>
        </van-popup>

        <van-dialog
            v-model="showRule"
            class="sports_item_rule_dialog rule"
            :show-confirm-button="false"
            close-on-click-overlay
            >
            <van-icon
                name="close"
                style="position:fixed;right:.1rem;"
                size=".4rem"
                @click="showRule=false"
            />
            <div
                class="rule"
            >
                <!-- <div
                class="header"
                slot="title"
                >{{title}}</div> -->
                <div v-html="rule"></div>
            </div>
        </van-dialog>
    </div>
</template>

<script>
import "./item.less";
import Form from '@/components/form/popform.vue'
import { Empty, Cell, CellGroup, Skeleton, Button, Image, Tag, Popup } from "vant";

export default {
    components: {
        Empty,
        Cell,
        CellGroup,
        Skeleton,
        Button,
        VanImage: Image,
        Tag,
        Popup,
        Form
    },
    props: ["item", "detail", "sports_id"],
    data() {
        return {
            showRule: false,
            subItemList: [],
            title: "",
            rule: "",
            enableActivity: false,
            scoreType: 1,
            content: "",
            canjoin: "",
            userInfo: {},
            attrs: [],
            registerinfos: null,
            showform: false,
            imglist: [
                {
                    icon: 'https://oss.mcloud.moveclub.cn/2025/draw/xin.png',
                    queid: '1338'
                },
                {
                    icon: 'https://oss.mcloud.moveclub.cn/2025/draw/da.png',
                    queid: '1339'
                }
            ],
            newsid: 30,
            istabimg: true,
            newslist: [],
        };
    },
    watch: {
        item: {
            handler: "getItemInfo",
            immediate: true,
            deep: true,
        },
    },
    mounted() {
        this.getUserInfo()
        this.getother();
        this.getnewslist();
    },
    methods: {
        goquest(acid) {
            this.$router.push({name:'newanswer',params: {acid: acid}})
        },
        submit: function (e) {
            this.$dialog.confirm({
                title: "提示",
                confirmButtonText: '确定提交',
                message: '信息提交后不可修改,确定提交?',
                showCancelButton: true
            }).then(() => {
                console.log(e)
                this.$api.activity.submitCombine({registerinfos:JSON.stringify(e),combile_id:51}).then((res) => {
                    if (+res.status === 200) {
                        this.getother()
                        this.showform = false
                    }
                })

                // on confirm
            }).catch(() => {
                // on cancel
            });
        },
        getother: function () {
            this.$api.activity.memberAttrList({typeid:1681}).then((res)=>{
                this.attrs = res.data.list[0]['attrs']
            })
            this.$api.activity.getCombine({combile_id:51}).then((res)=>{
                let {disclaimer_url,registerinfos} = res.data;
                this.registerinfos = registerinfos?registerinfos:null
            })

        },
        getUserInfo() {
            this.$api.user.getUserInfo().then((res) => {
                if (res.status * 1 === 200) {
                    this.userInfo = res.data
                }
            })
        },
        getnewslist() { 
            this.$api.common.getNews({category_id: this.newsid}).then((res) => { 
                this.newslist = res.data.list
            })
        },
        gonewsdetail(id) {
            // this.$router.push({name: 'newsdetail', params: {news_id: id}})
            wx.miniProgram.navigateTo({
                url: `/v2/news/detail/index?id=${id}`
            });
        },
        go(val) {      
            let that = this
            var {jumptype, jumpvalue, jumpurl} = val;
                //跳转类型：1，内部跳转；2，外部url跳转
            switch (jumptype * 1) {
                case 1:
                wx.miniProgram.navigateTo({
                    url: val.register_type_value
                })
                    break;
                case 2:
                    //参数带上 用户信息
                    // if(data.url)
                    window.location.href = jumpurl
                    break;
                case 3:
                    that.show = true
                    // that.$toast.fail('该功能只对小程序开放');
                    break;
            }
        },
        goDetail(val) {
            if(!this.registerinfos) {
                this.showform = true
                return
            }
            if(val.register_type_value){
                if(val.register_type_value.indexOf('http')!=-1){
                    window.location.href = val.register_type_value
                } else {
                    wx.miniProgram.navigateTo({
                        url: val.register_type_value
                    })
                }
                
                return
            }
            this.$router.push({name:'sportsDetail',params:{sports_id:val.sports_id,item_id:this.item.id,item_sub_id:val.id}})
                 
        },
        goTab() {
            if(!this.registerinfos) {
                this.showform = true
                return
            }
      
            if(this.item.id == 497) {
                let val = this.subItemList[0]  
                if(val.register_type == 2){
                    window.location.href = val.register_type_value
                    return
                }
                if(val.register_type_value){
                    if(val.register_type_value.indexOf('http')!=-1){
                        window.location.href = val.register_type_value
                    } else {
                        wx.miniProgram.navigateTo({
                            url: val.register_type_value
                        })
                    }
                    
                    return
                }   
                this.$router.push({name:'sportsDetail',params:{sports_id:val.sports_id,item_id:this.item.id,item_sub_id:val.id}})
            } else {       
                this.$router.push({name:'jd_item',params:{item_id:this.item.id}})
            }
        },
        getItemInfo() {
            console.log(this.item,'item')
            if(!this.item.id) return
            this.subItemList = [];
            this.rule = "";
            this.enableActivity = false
            this.$api.sports.getItemSubs({ itemid: this.item.id }).then((res) => {
                this.subItemList = res.data.list;
                this.title = res.data.title;
                this.content = res.data.content;
                this.rule = res.data.rule;
                this.scoreType = res.data.score_type;
                this.canjoin = res.data.canjoin;
                if (+res.data.list.length === 1) {
                let {
                    title,
                    start_time,
                    end_time,
                    vote_start_time,
                    vote_end_time,
                } = res.data.list[0];
                // this.title = title;
                this.enableActivity = res.sys_time > start_time;
                }
            });
        },
    }
}
</script>